import { render, staticRenderFns } from "./CardTitle.vue?vue&type=template&id=4732f56c&"
import script from "./CardTitle.vue?vue&type=script&lang=js&"
export * from "./CardTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports